import { polyfill } from './helpers/polyfill';
polyfill();
// import { isIE } from './helpers/browser-detection';

import onDocumentLoad from "./helpers/on-document-load";
import { NavController } from "./controller/nav.controller";
import { UIController } from "./controller/ui.controller";
import { HomeController } from './controller/home.controller';

// import SwiperCore, { Pagination, EffectFade, Autoplay } from 'swiper/core';

// if (!isIE) {
//   SwiperCore.use([Pagination, EffectFade, Autoplay]);
// }

export const APP = {
  init() {
    return new Promise(async (resolve, reject) => {
      try {
        // await UIController.init();
        // await NavController.init();
        // HomeController.init();
        resolve();
      } catch(error) {
        reject(error);
      }
    })
  }
}

// console.log('child theme loaded');
onDocumentLoad(APP.init);